import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import { ExternalIntegrationVendor } from 'dashboard/models/external-integration-vendor';
import ExternalIntegrationVendorsView from 'dashboard/views/DashboardExternalIntegrationsView/ExternalIntegrationVendorsView';

interface DashboardExternalIntegrationsViewProps {
  externalIntegrationVendors: ExternalIntegrationVendor[];
}

const DashboardExternalIntegrationsView = ({
  externalIntegrationVendors,
}: DashboardExternalIntegrationsViewProps) => {
  return (
    <Container>
      <Header title='Marketplace' />
      <Section>
        <ExternalIntegrationVendorsView externalIntegrationVendors={externalIntegrationVendors} />
      </Section>
    </Container>
  );
};

export default DashboardExternalIntegrationsView;
